import { Injectable, inject } from '@angular/core'

import type { Observable } from 'rxjs'
import { throwError } from 'rxjs'
import { catchError, map } from 'rxjs/operators'

import { ApiService } from '../api.service'
import type { AuthorDto, AuthorsResponseDto } from '../responses'

@Injectable({
  providedIn: 'root',
})
export class AuthorsService {
  private readonly apiService = inject(ApiService)

  getAuthors(
    page: number,
    limit: number,
    sort_field = 'last_name',
    sort_order: 'asc' | 'desc' = 'asc',
    where?: Record<string, unknown>
  ): Observable<AuthorsResponseDto> {
    return this.apiService
      .getAuthors(
        page,
        limit,
        undefined,
        `${sort_order === 'desc' ? '-' : ''}${sort_field}`,
        where
      )
      .pipe(
        map(result => {
          return result.data
        }),
        catchError((error: unknown) => {
          console.error('Error in getAuthors:', error)
          return throwError(() => error)
        })
      )
  }

  getAuthorById(id: number): Observable<AuthorDto | undefined> {
    return this.apiService.getAuthorById(id).pipe(
      map(result => {
        const author = result.data.Author

        // Add the type property with proper literal type
        return {
          ...author,
          type: 'author' as const,
          // We don't add company_url and linkedin_url since they're not in the AuthorDto type
        }
      }),
      catchError((error: unknown) => throwError(() => error))
    )
  }

  searchAuthors(firstName: string, lastName: string): Observable<number[]> {
    return this.apiService.searchAuthors(firstName, lastName).pipe(
      map(result => result.data.Authors.docs.map(author => author.id)),
      catchError((error: unknown) => throwError(() => error))
    )
  }
}
